import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import "./App.css";
import Login from "./Components/Login/Login";
import "@fortawesome/fontawesome-free/css/all.css";
import ForgotPassword from "./Components/ForgotPassword/ForgotPassword";
import ResetPassword from "./Components/ResetPassword/ResetPassword";
import Content from "./Components/Content/Content";
import Layout from "./Components/Layout/Layout";
import LoadingScreen from "./Components/LoadingScreen/LoadingScreen";
import Chat from "./Components/Chat/Chat";
import "flowbite";
import "tailwindcss/tailwind.css";
import HistoryChat from "./Components/HistoryChat/HistoryChat";
import PrivateRoute from "./utils/PrivateRoute";
import { QuestionProvider } from './context/QuestionContext';
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <AuthProvider>
      <QuestionProvider>
        <BrowserRouter>
          <div className="App">
            <Routes>
              {/* <Route index element={<LoadingScreen />} /> */}
              {/* <Route path="/" element={<LoadingScreen />} /> */}

              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />

              <Route path="/" element={
                <PrivateRoute>
                  <Layout />
                </PrivateRoute>
              }>
                <Route index element={<Content />} />
                <Route path="send" element={<Chat />} />
                <Route path="history/:sessionId" element={<HistoryChat />} />
              </Route>
            </Routes>
          </div>
        </BrowserRouter>
      </QuestionProvider>
    </AuthProvider>
  );
}

export default App;
